import styled from 'styled-components';

const Section = styled.section<any>`
  width: 100%;
  padding: 1rem 1.5rem;
  box-sizing: border-box;

  &:first-child {
    padding-top: 96px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    &:first-child {
      padding-top: 0;
    }
  }

  &:not(:first-child) {
    background: ${(props) => props.theme.colors.white};
  }
`;

export default Section;
